/**
 * Názvy častí zákazky (KOLO 203/205) — zrkadlo `casti_zakazky.nazov_casti`.
 *
 * Časť sa pri ďalšom importe páruje s dovetkom Určení (`AA6262_obyvacka`)
 * podľa `urceni_casti`, a kým ho nemá, podľa svojho názvu. Predvolený názov
 * preto berie dovetok, keď ho výpočet pozná.
 */
import type { Varianta } from "@/api/schemas";

const MAX_NAZOV = 50;

/** `skrinka_prava` → `Skrinka prava`, do 50 znakov. */
export function nazovCasti(text: string): string {
  const t = text.replace(/_/g, " ").split(/\s+/).filter(Boolean).join(" ");
  return (t.charAt(0).toUpperCase() + t.slice(1)).slice(0, MAX_NAZOV);
}

/** Návrh názvu, pod ktorým sa výpočet stane časťou. */
export function navrhNazvuCasti(
  v: Pick<Varianta, "nazov" | "urceni_casti">,
): string {
  const urceni = v.urceni_casti?.trim();
  return urceni ? nazovCasti(urceni) : v.nazov;
}
